import type { DashboardData } from './types'

export function getTotalCurrentFtes(data?: Pick<DashboardData, 'subfunctions'>): number {
  return (data?.subfunctions ?? []).reduce(
    (total, subfunction) =>
      total +
      Object.values(subfunction.roles ?? {}).reduce(
        (roleTotal, role) => roleTotal + (Number(role.ftes) || 0),
        0,
      ),
    0,
  )
}
